import { documentModelNS } from '../../document.baseType';
import { iDocRouteData, iDocRouteOldShareData } from '../docRoute.type';

/** Reducers Action */
// 更新路由数据 Action
export const updateRouteDataAction = (payload: iDocRouteData) => ({
  type: 'updateRouteDataReducer',
  payload,
});
// 更新老分享路由数据 Action
export const updateOldShareRouteDataAction = (
  payload: iDocRouteOldShareData,
) => ({
  type: `${documentModelNS}/updateOldShareRouteDataReducer`,
  payload,
});

/** Effects Action */
// 初始化更新路由 Action
export const initRouteDataAction = () => ({
  type: `${documentModelNS}/initRouteDataEffect`,
});
